import type { Device } from 'src/types/Device';
import type { SettingRequest } from '@shelly/device-templates/src/lib/types/SettingRequest';
import { gen2Request } from 'src/services/gen_2_http_reqs';

export const sendRequest = async (dev: Device, method: string, params: any): Promise<SettingRequest> => {
	return gen2Request(dev, method, params);
};

export const isDefaultTemplateType = (serviceType: string | undefined): boolean => {
	return (serviceType?.split(':')?.length ?? 0) > 1;
};
